import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import CopyBtn from '../../../../../components/button/CopyBtn';
import { currency } from './Currency';
import { CRASH_STATUS, GameIds } from 'src/configs/game.config';
import { useTranslate } from 'react-admin';
import CopyAll from 'src/components/button/CopyAll';
import { f } from 'src/utils/format';

export enum TrenBallType {
  Blue = 'Blue',
  Green = 'Green',
  None = 'None',
  Red = 'Red',
  Yellow = 'Yellow',
}

export const RocketBetDetail = React.memo(
  ({ order }: { order: any }) => {
    const t = useTranslate();

    const isWin = +order?.reward > 0;

    const isRoundFinished = order?.crashRound?.status === CRASH_STATUS.End;
    const betCalculated = isRoundFinished || (order.reward?.gt(0) ?? false);
    const gameId = order.gameId;
    // const currencyUsed = currencyMap[order.currency];
    // const { isOpen, onOpen, onClose } = useDisclosure();
    const textGrayDrawer = '#b3b3b7';
    const currencyUsed = currency.find((i) => i.name === order.currency);

    const formatOrderId = (orderId?: string) => {
      if (!orderId) return '';

      const formatOrderIdRegex = /^(.{8}).*(.{8})$/;

      return orderId.replace(formatOrderIdRegex, '$1...$2');
      // cf05be8a-dc5f-4a48-9424-0d90fae652db => cf05be8a...fae652db
    };

    return (
      <>
        <Box bgcolor="#2f2f31" className="newgame-container">
          <Stack p={4} bgcolor="#2f2f31" color={'#fff'} gap={0}>
            <Typography fontWeight={600} fontSize="22px" mt={2}>
              {t(gameId)}
            </Typography>
            <Box display={'flex'} gap={2} alignItems="center" lineHeight={1.2}>
              <Typography fontSize={32} fontWeight={600} color={isWin ? '#B0FC00' : '#ff5959'}>
                {isWin ? (
                  <>{`+${f(+order?.reward, {
                    decimal: currencyUsed?.decimal,
                  })}`}</>
                ) : (
                  <>
                    {f(+order?.amount, {
                      decimal: currencyUsed?.decimal,
                    })}
                  </>
                )}
              </Typography>
              {currencyUsed?.icon}
              {/* <Image src={getSymbolFromCurrency(order?.currency)} className="w-6 h-6 rounded-lg" /> */}
            </Box>
            <Stack
              flexDirection="row"
              justifyContent="space-between"
              color={isWin ? '#B0FC00' : '#ff5959'}
            >
              <Typography>{betCalculated ? (isWin ? t('win') : t('lose')) : ''}</Typography>
              {betCalculated && (
                <Typography>{t('module.game.gameDetail.statusPayment')}</Typography>
              )}
            </Stack>
          </Stack>
          <Stack p={4} color={'#fff'} borderRadius="14px 14px 0 0" bgcolor="#363639" gap="10px">
            {/* <Stack>
              <Box display="flex" justifyContent="space-between" py={1}>
                <Typography color={textGrayDrawer}>{t('game')}</Typography>
                <Typography fontWeight={400}>{t(gameId)}</Typography>
              </Box>
            </Stack> */}
            <Stack>
              <hr style={{ borderColor: '#434343' }} />
              <Box display="flex" justifyContent="space-between" py={1}>
                <Typography color={textGrayDrawer}>
                  {t('module.game.gameDetail.betAmount')}
                </Typography>
                <Box display={'flex'} gap={1} alignItems="center">
                  <Typography fontWeight={400}>
                    {f(+order?.amount, {
                      decimal: currencyUsed?.decimal,
                    })}{' '}
                  </Typography>
                  {currency.find((i) => i.name === order?.currency)?.icon}
                </Box>
              </Box>
            </Stack>
            {order?.trenBallType === TrenBallType.None ? (
              <Stack>
                <hr style={{ borderColor: '#434343' }} />
                <Box display="flex" justifyContent="space-between" py={1}>
                  <Typography color={textGrayDrawer}>
                    {gameId === GameIds.H_ROCKET && t('module.game.gameDetail.skydivingAltitude')}
                    {gameId === GameIds.H_TSHOW && t('module.game.gameDetail.catwalkDistance')}
                  </Typography>
                  {order.cashOut !== '0' || order?.autoCashOut !== '0' ? (
                    <Typography fontWeight={400} color="#ffffff">
                      x
                      {f(order.cashOut !== '0' ? order.cashOut : order.autoCashOut, {
                        decimal: currencyUsed?.decimal,
                      })}
                    </Typography>
                  ) : (
                    <Typography fontWeight={400} lineHeight={0.5} color="#ffffff">
                      __
                    </Typography>
                  )}
                </Box>
              </Stack>
            ) : (
              <Stack>
                <hr style={{ borderColor: '#434343' }} />
                <Box display="flex" justifyContent="space-between" py={1}>
                  <Typography color={textGrayDrawer}>
                    {gameId === GameIds.H_ROCKET && t('module.game.gameDetail.trenball')}
                  </Typography>
                  <Typography
                    fontWeight={400}
                    lineHeight={1}
                    color="#ffffff"
                    // className={classNames('', {
                    //   'text-[#d52b4f]': order?.tren_ball_type === TrenBallType.Red,
                    //   'text-[#ff9600]': order?.tren_ball_type === TrenBallType.Yellow,
                    //   'text-[#27a052]': order?.tren_ball_type === TrenBallType.Green,
                    //   'text-[#0a79df]': order?.tren_ball_type === TrenBallType.Blue,
                    // })}
                  >
                    {order.trenBallType === TrenBallType.Yellow && 'Crash'}
                    {order.trenBallType === TrenBallType.Green && t('module.game.gameDetail.green')}
                    {order.trenBallType === TrenBallType.Red && t('module.game.gameDetail.red')}
                    {order.trenBallType === TrenBallType.Blue && t('module.game.gameDetail.moon')}
                  </Typography>
                </Box>
              </Stack>
            )}

            <Stack>
              <hr style={{ borderColor: '#434343' }} />
              <Box display="flex" justifyContent="space-between" py={1}>
                <Typography color={textGrayDrawer}>
                  {gameId === GameIds.H_ROCKET && t('module.game.gameDetail.explosionAltitude')}
                  {gameId === GameIds.H_TSHOW && t('module.game.gameDetail.distance')}
                </Typography>
                <Typography fontWeight={400} color="#ffffff">
                  {isRoundFinished
                    ? `x${f(order.multiplier, {
                        decimal: currencyUsed?.decimal,
                      })}`
                    : '--'}
                </Typography>
              </Box>
            </Stack>
            <Stack>
              <hr style={{ borderColor: '#434343' }} />
              <Box display="flex" justifyContent="space-between" py={1}>
                <Typography color={textGrayDrawer}>{t('module.game.gameDetail.rebate')}</Typography>
                <Box display={'flex'} gap={1} alignItems="center">
                  <Typography fontWeight={400} color={isWin ? '#B0FC00' : '#ff5959'}>
                    {isWin ? (
                      <>{`+${f(+order?.reward, {
                        decimal: currencyUsed?.decimal,
                      })}`}</>
                    ) : (
                      <>
                        {f(+order?.amount, {
                          decimal: currencyUsed?.decimal,
                        })}
                      </>
                    )}
                  </Typography>
                  {currencyUsed?.icon}
                </Box>
              </Box>
            </Stack>
            <Stack>
              <hr style={{ borderColor: '#434343' }} />
              <Box display="flex" justifyContent="space-between" py={1}>
                <Typography color={textGrayDrawer}>
                  {t('module.game.gameDetail.betTime')}
                </Typography>
                <Box display={'flex'} gap={1} alignItems="center">
                  <Typography fontWeight={400}>
                    {dayjs(order.time).format('YYYY-MM-DD HH:mm:ss')}
                  </Typography>
                </Box>
              </Box>
            </Stack>
            <Stack>
              <hr style={{ borderColor: '#434343' }} />
              <Box display={'flex'} justifyContent="space-between" py={1}>
                <Typography color={textGrayDrawer}>
                  {t('module.game.gameDetail.orderId')}
                </Typography>
                <Box display={'flex'} gap={1} alignItems="center">
                  <Typography fontWeight={400}>{formatOrderId(order?.id)}</Typography>
                  <CopyBtn text={order?.id} />
                </Box>
              </Box>
            </Stack>
            {isRoundFinished && (
              <>
                <Stack>
                  <hr style={{ borderColor: '#434343' }} />
                  <Stack gap="0">
                    <Box display="flex" alignItems="center" justifyContent="space-between" py={1}>
                      <Typography color={textGrayDrawer}>
                        {t('module.game.gameDetail.hashValue')}
                      </Typography>
                      <CopyBtn text={order?.crashRound?.randomValue} />
                    </Box>
                    <Typography
                      fontWeight={400}
                      sx={{
                        overflowWrap: 'anywhere',
                      }}
                    >
                      {order?.crashRound?.randomValue}
                    </Typography>
                  </Stack>
                </Stack>
                <Stack>
                  <hr style={{ borderColor: '#434343' }} />
                  <Stack gap="0">
                    <Box display="flex" alignItems="center" justifyContent="space-between" py={1}>
                      <Typography color={textGrayDrawer}>
                        {t('module.game.gameDetail.serverSeed')}
                      </Typography>
                      <CopyBtn text={order?.crashRound?.serverSeed} />
                    </Box>
                    <Typography
                      fontWeight={400}
                      sx={{
                        overflowWrap: 'anywhere',
                      }}
                    >
                      {order?.crashRound?.serverSeed}
                    </Typography>
                  </Stack>
                </Stack>
                <Stack>
                  <hr style={{ borderColor: '#434343' }} />
                  <Stack gap="0">
                    <Box display="flex" alignItems="center" justifyContent="space-between" py={1}>
                      <Typography color={textGrayDrawer}>
                        {t('module.game.gameDetail.clientSeed')}
                      </Typography>
                      <CopyBtn text={order?.crashRound?.clientSeed} />
                    </Box>
                    <Typography
                      fontWeight={400}
                      sx={{
                        overflowWrap: 'anywhere',
                      }}
                    >
                      {order?.crashRound?.clientSeed}
                    </Typography>
                  </Stack>
                </Stack>
                <CopyAll
                  cpyTxt={`${order?.crashRound?.randomValue}${order?.crashRound?.serverSeed}${order?.crashRound?.clientSeed}`}
                  handeClick={() => {
                    window.open(
                      `https://emn178.github.io/online-tools/sha256.html?input=${order?.crashRound?.randomValue}${order?.crashRound?.serverSeed}${order?.crashRound?.clientSeed}`,
                      '_blank'
                    );
                  }}
                />
                <Stack>
                  <hr style={{ borderColor: '#434343' }} />
                  <Stack gap="0">
                    <Box display="flex" alignItems="center" justifyContent="space-between" py={1}>
                      <Typography color={textGrayDrawer}>
                        {t('module.game.gameDetail.proof')}
                      </Typography>
                      <CopyBtn text={order?.crashRound?.proof} />
                    </Box>
                    <Typography
                      fontWeight={400}
                      sx={{
                        overflowWrap: 'anywhere',
                      }}
                    >
                      {order?.crashRound?.proof}
                    </Typography>
                  </Stack>
                </Stack>
              </>
            )}
          </Stack>
        </Box>
      </>
    );
  },
  () => true
);
